import { CopyableValue } from '@/components/ui';
import styles from './AppDetailConnectionTab.module.css';

/** A labelled read-only value with a copy affordance; `—` when there is no value. */
export function ValueRow({ label, value }: { label: string; value: string | null }) {
    return (
        <div className={styles.codeField} data-testid="app-detail-code-field">
            <span className={styles.codeFieldLabel}>{label}</span>
            {value ? <CopyableValue value={value} ariaLabel={label} /> : <code>—</code>}
        </div>
    );
}

export default ValueRow;
